import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import { InferResponseType } from "hono";

export type GetLomdaResponseType = InferResponseType<
    (typeof client.api.storage.lomda)[":lomdaId"]["$get"],
    200
>;

export const useGetLomda = (enabled: boolean, lomdaId: string) => {
    const query = useQuery({
        enabled,
        queryKey: ["get-lomda", lomdaId],
        queryFn: async () => {
            const response = await client.api.storage.lomda[":lomdaId"].$get({
                param: { lomdaId },
            });

            if (!response.ok) throw new Error("Failed to fetch lomda");

            const { data } = await response.json();
            return { data };
        },
    });

    return query;
};
